module.exports = __webpack_public_path__ + "img/cs2_01.653cada9.jpg";